import React from 'react';
import { connect } from 'react-redux';
import { InformationCircleIcon, PencilIcon, TrashIcon } from '@heroicons/react/24/outline';

const TbodyTableConciliaciones = (props) => {
  const infoConciliacion = props.conciliacion.conciliacion || [];
  const { handleEdit, handleDelete, handleShowDetails } = props.actions;

  const resolveValue = (obj, keys, fallback = '') => {
    for (let i = 0; i < keys.length; i += 1) {
      const key = keys[i];
      if (obj && obj[key] !== undefined && obj[key] !== null) {
        return obj[key];
      }
    }
    return fallback;
  };

  const formatToken = (value) => {
    if (!value || typeof value !== 'string') {
      return '';
    }
    if (value.length <= 14) {
      return value;
    }
    return `${value.slice(0, 8)}...${value.slice(-4)}`;
  };

  const formatDate = (value) => {
    if (!value) {
      return '';
    }
    if (typeof value === 'string') {
      const normalized = value.replace('T', ' ');
      if (normalized.length >= 16 && /\d{4}-\d{2}-\d{2}/.test(normalized)) {
        return normalized.slice(0, 16);
      }
    }
    const date = new Date(value);
    if (Number.isNaN(date.getTime())) {
      return value;
    }
    const pad = (number) => String(number).padStart(2, '0');
    return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())} ${pad(date.getHours())}:${pad(date.getMinutes())}`;
  };

  const getBaseName = (value) => {
    if (!value || typeof value !== 'string') {
      return '';
    }
    const parts = value.split('/');
    return parts[parts.length - 1] || value;
  };

  const getFileName = (obj) => {
    const archivoValue = resolveValue(obj, ['ARCHIVO_NOMBRE', 'archivo_nombre', 'archivo', 'ARCHIVO'], '');
    if (typeof archivoValue === 'string' && archivoValue.length > 0) {
      return archivoValue;
    }
    return (
      resolveValue(obj, ['file_name', 'FILE_NAME', 'ARCHIVO_RUTA', 'archivo_ruta'], '') ||
      resolveValue(obj?.file || {}, ['name', 'path'], '') ||
      resolveValue(obj?.archivo || {}, ['name', 'path'], '')
    );
  };

  if (infoConciliacion.length === 0) {
    return (
      <tbody className="text-gray-700">
        <tr>
          <td
            className="px-2 py-3 text-center text-sm text-gray-500"
            colSpan={13}>
            Sin registros
          </td>
        </tr>
      </tbody>
    );
  }

  return (
    <tbody className="text-gray-700">
      {infoConciliacion.map((obj, index) => (
        <tr
          key={index}
          className="odd:bg-white even:bg-gray-50 hover:bg-gray-100">
          <td className="px-2 py-2 text-left align-middle">{resolveValue(obj, ['id', 'ID', 'TAKEOFF_IMPORT_ID'], '')}</td>
          <td className="px-2 py-2 text-left align-middle font-mono text-xs">
            <span title={resolveValue(obj, ['token', 'TOKEN'], '')}>{formatToken(resolveValue(obj, ['token', 'TOKEN'], ''))}</span>
          </td>
          <td className="whitespace-nowrap px-2 py-2 text-left align-middle">{resolveValue(obj, ['estado', 'ESTADO'], '')}</td>
          <td className="px-2 py-2 text-left align-middle">
            <div
              className="max-w-[320px] truncate"
              title={getFileName(obj)}>
              {getBaseName(getFileName(obj))}
            </div>
          </td>
          <td className="px-2 py-2 text-left align-middle">
            <div
              className="max-w-[200px] truncate"
              title={resolveValue(obj, ['hoja_nombre', 'HOJA_NOMBRE', 'sheet_name'], '')}>
              {resolveValue(obj, ['hoja_nombre', 'HOJA_NOMBRE', 'sheet_name'], '')}
            </div>
          </td>
          <td className="px-2 py-2 text-right align-middle tabular-nums">{resolveValue(obj, ['total_filas', 'TOTAL_FILAS', 'total_rows'], 0)}</td>
          <td className="whitespace-nowrap px-2 py-2 text-left align-middle">{resolveValue(obj, ['usuario_id', 'USUARIO_ID'], '-') || '-'}</td>
          <td className="whitespace-nowrap px-2 py-2 text-left align-middle tabular-nums">
            {formatDate(resolveValue(obj, ['created_at', 'CREATED_AT', 'fecha', 'FECHA'], ''))}
          </td>
          <td className="whitespace-nowrap px-2 py-2 text-left align-middle tabular-nums">{formatDate(resolveValue(obj, ['updated_at', 'UPDATED_AT'], ''))}</td>
          <td className="whitespace-nowrap px-2 py-2 text-right align-middle tabular-nums">
            {resolveValue(obj, ['validas', 'VALIDAS', 'validas_count'], 0)}/
            {resolveValue(obj, ['errores', 'ERRORES', 'invalidas', 'INVALIDAS', 'invalidas_count'], 0)}
          </td>
          <td className="px-1 py-2 text-center align-middle">
            <InformationCircleIcon
              className="h-5 w-5 transform cursor-pointer transition duration-300 hover:scale-110"
              onClick={() => handleShowDetails?.(obj)}
            />
          </td>

          <td className="px-1 py-2 text-center align-middle">
            <TrashIcon
              className="h-5 w-5 transform cursor-pointer transition duration-300 hover:scale-110"
              onClick={() => handleDelete?.(resolveValue(obj, ['id', 'ID', 'TAKEOFF_IMPORT_ID', 'CONCILIACION_ID'], index))}
            />
          </td>
        </tr>
      ))}
    </tbody>
  );
};

const mapStateToProps = function (state) {
  return { conciliacion: state.conciliacion };
};

export default connect(mapStateToProps)(TbodyTableConciliaciones);
